export const projectKeys = {
  all: ['projects'] as const,
  parts: ['project-parts'] as const,
  categories: ['project-categories'] as const,

  lists: () => [...projectKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown> = {}) =>
    [...projectKeys.lists(), filters] as const,
  listMe: (filters: Record<string, unknown> = {}) =>
    [...projectKeys.lists(), 'me', filters] as const,

  users: () => [...projectKeys.all, 'user'] as const,
  user: (id: number, filters: Record<string, unknown> = {}) =>
    [...projectKeys.users(), id, filters] as const,

  favorites: () => [...projectKeys.all, 'favorites'] as const,
  favorite: (filters: Record<string, unknown> = {}) =>
    [...projectKeys.favorites(), filters] as const,

  details: () => [...projectKeys.all, 'details'] as const,
  detail: (projectId: number) => [...projectKeys.details(), projectId] as const,
  detailMe: (projectId: number) =>
    [...projectKeys.details(), 'me', projectId] as const,

  chats: () => [...projectKeys.all, 'chat'] as const,
  chat: (id: number) => [...projectKeys.chats(), id] as const,
  chatProject: (projectId: number) =>
    [...projectKeys.chats(), 'project', projectId] as const,
  chatMe: () => [...projectKeys.chats(), 'me'] as const
}

export const stagedDesign = (locale: string) => {
  return Object.entries({
    'feasibility-study':
      locale === 'ru'
        ? 'Технико-экономическое обоснование (ТЭО)'
        : 'Feasibility Study (TES)',
    'feasibility-calculation':
      locale === 'ru'
        ? 'Технико-экономический расчёт (ТЭР)'
        : 'Technical and economic calculation (TEC)',
    'preliminary-design':
      locale === 'ru' ? 'Эскизный проект (ЭП)' : 'Draft design (ED)',
    project: locale === 'ru' ? 'Проект (П)' : 'Project (P)',
    'work-project':
      locale === 'ru' ? 'Рабочий проект (РП)' : 'Working draft (DP)',
    'work-documentation':
      locale === 'ru' ? 'Рабочая документация (Р)' : 'Working documentation (P)'
  })
}
